// Model.js
// -----------------------
// @module Case
define("BluePoint.SegregateItems.SegregateItems.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/SegregateItems/SuiteScript2/SegregateItems.Service.ss"
            ),
            true
        )
});
});
